<script lang="typescript">
  // packages
  import { intcomma } from 'journalize';

  // utils
  import apstate from '../utils/apstate';

  // types
  import type { OfficeRaceInterface } from '../interfaces';

  export let results: OfficeRaceInterface[];
  export let includeLinks = true;

  function prepareResults(states: OfficeRaceInterface[]) {
    return states.map((state) => {
      const name = state.name;
      const shortName = apstate.get(state.code)!.ap;
      const stateLink = `../${apstate.get(state.code)!.slug}/`;
      const eevp = state.eevp;
      const electoralVotes = state.electors_total;
      const totalVotes = state.total_votes;

      const leader = state.candidates[0];
      const second = state.candidates[1];

      const leaderName = leader.family_name;
      const leaderIsWinner = leader.is_winner;
      const leaderMargin = leader.votes - second.votes;
      const leaderParty = leader.party;
      const leaderPctMargin = (
        (leader.votes / totalVotes - second.votes / totalVotes) *
        100
      ).toFixed(1);

      return {
        name,
        shortName,
        stateLink,
        eevp,
        electoralVotes,
        leaderName,
        leaderIsWinner,
        leaderParty,
        leaderMargin,
        leaderPctMargin,
      };
    });
  }
</script>

<table class="states-to-watch-table text-sans-serif text-sm w-full mb-n4">
  <thead class="text-xs">
    <tr>
      <th
        scope="col"
        class="text-left border-color-bar-grey border-solid border-b px-n3 py-n2">
        State
      </th>
      <th
        scope="col"
        class="text-center border-color-bar-grey border-solid border-b px-n3 py-n2">
        E.V.
      </th>
      <th
        scope="col"
        class="text-left border-color-bar-grey border-solid border-b px-n3 py-n2">
        Leader
      </th>
      <th
        scope="col"
        class="text-right border-color-bar-grey border-solid border-b px-n3 py-n2">
        Margin
      </th>
      <th
        scope="col"
        class="text-right whitespace-no-wrap border-color-bar-grey border-solid border-b px-n3 py-n2">
        Est. votes<span class="hidden xs:display-inline">&nbsp;in</span>
      </th>
    </tr>
  </thead>
  <tbody>
    {#each prepareResults(results) as state}
      <tr>
        <th
          scope="row"
          class="text-left px-n3 py-n2 border-color-bar-grey border-solid border-b text-medium">
          {#if includeLinks}
            <a href={state.stateLink}>
              <span class="hidden sm:display-inline">{state.name}</span>
              <span class="sm:hidden">{state.shortName}</span>
            </a>
          {:else}
            <span class="hidden sm:display-inline">{state.name}</span>
            <span class="sm:hidden">{state.shortName}</span>
          {/if}
        </th>
        <th
          scope="row"
          class="text-center px-n3 py-n2 border-color-bar-grey color-grey border-solid border-b">
          {state.electoralVotes}
        </th>
        <td
          class="text-left px-n3 py-n2 border-color-bar-grey border-solid border-b color-{state.leaderParty}-dark"
          class:text-bold={state.leaderIsWinner}>
          {state.leaderName}
          {#if state.leaderIsWinner}✓{/if}
        </td>
        <td
          class="text-right px-n3 py-n2 border-color-bar-grey border-solid border-b color-{state.leaderParty}-dark"
          class:text-bold={state.leaderIsWinner}>
          +{intcomma(state.leaderMargin)}
        </td>
        <td
          class="text-right px-n3 py-n2 border-color-bar-grey color-grey border-solid border-b">
          {state.eevp}%
        </td>
      </tr>
    {/each}
  </tbody>
</table>
<small class="text-sans-serif text-xs color-grey">✓ Called winner by AP</small>
